import { withCurrentParams } from 'actions/utils';
import { BROADCAST_GET_SERVER_TIME } from 'actions/Types';
import { BROADCAST_JOIN_SYNC_SERVER_TIME } from 'store/eventConstants';

function getServerTime() {
  return withCurrentParams((dispatch, { broadcastId }, _, socket) => {
    const action = {
      type: BROADCAST_GET_SERVER_TIME
    };

    socket.emit(BROADCAST_JOIN_SYNC_SERVER_TIME, { broadcastId });

    dispatch(action);
  });
}

export default getServerTime;
